/*
 * @Author: tao_yang
 * @Date: 2023-02-28 17:31:19
 * @LastEditors: tao_yang
 * @LastEditTime: 2023-02-28 17:38:06
 * @Description: 请填写简介
 */
import InvitePage from '&/pages/invite-pages';
import {
    HomePage,
    UserCenter,
    LoginPages,
    RetrievePassword,
    HouseType,
    ModelBase,
    LandingPage,
    PricingPage,
} from '@/pages';

import PreviewPDF from '&/pages/PreviewPDF/PreviewPdfMini';
import CollectionShare from '&/pages/my-collection/CollectionShare';
import PanoramaShare from '&/pages/hdd-pages/panoramaShare';
import DesignPreview from '&/pages/design-preview';
import SchemePreview from '&/pages/scheme-preview';
import Panorama from '&/pages/home-page/ExcellentDesign/panorama';
import FloorPlanPreview from '&/pages/floor-plan-design/preview';

const ROUTE_LIST = [
    { path: '/home', component: HomePage },
    { path: '/model-base', component: ModelBase },
    { path: '/user-center', component: UserCenter },
    { path: '/retrieve-password', component: RetrievePassword },
    { path: '/login', component: LoginPages },
    { path: '/house-type', component: HouseType },
    { path: '/landing', component: LandingPage },
    { path: '/pricing-page', component: PricingPage },
];

// 单独页面（无header、footer等）
export const EXCLUSIVE_ROUTES = [
    {
        path: '/preview-pdf',
        component: PreviewPDF,
        needIntercept: false,
    },
    {
        path: '/collection-share',
        component: CollectionShare,
        needIntercept: true, // 是否路由拦截
    },
    {
        path: '/hdd/panoramaShare',
        component: PanoramaShare,
        needIntercept: false,
    },
    {
        path: '/design/preview',
        component: DesignPreview,
        needIntercept: false,
    },
    {
        path: '/scheme-preview/drawing',
        component: SchemePreview,
        needIntercept: false,
    },
    {
        path: '/invite',
        component: InvitePage,
        needIntercept: true,
    },
    {
        path: '/home/panorama/:id',
        component: Panorama,
        needIntercept: false,
    },
    {
        path: '/home/floorPlan/preview/:id',
        component: FloorPlanPreview,
        needIntercept: false,
    },
];

export default ROUTE_LIST;
